<template>
    <div class="box">
        <el-form label-width="auto">

            <el-form-item label="标题">
                <el-input v-model="myObj.photo_classify_plat_params.title" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="间距">
                <el-input-number v-model="myObj.photo_classify_plat_params.margin" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="展示个数">
                <el-input-number v-model="myObj.component_source.params.total" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="列数">
                <el-input-number v-model="myObj.photo_classify_plat_params.column" :min="1" :max="5"></el-input-number>
            </el-form-item>

            <el-form-item label="图片高(宽高比)">
                <el-input-number v-model="myObj.photo_classify_plat_params.item_height_ratio"
                    :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="图片圆角">
                <el-input-number v-model="myObj.photo_classify_plat_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素间距">
                <el-input-number v-model="myObj.photo_classify_plat_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="文字位置">
                <el-select v-model="myObj.photo_classify_plat_params.text_position">
                    <el-option v-for="item, index in positionOptions" :label="item.name" :value="item.value"
                        :key="index"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="文字显示">
                <el-switch v-model="myObj.photo_classify_plat_params.text_show" :active-value="1"
                    :inactive-value="0"></el-switch>
            </el-form-item>

            <ComponentSource :component_source="obj.component_source" />


        </el-form>
    </div>
</template>

<script>

import ComponentSource from '../../ComponentSource/ComponentSource.vue';

export default {
    name: "PhotoClassifyPlatProp",
    components: {
        ComponentSource
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            positionOptions: [
                { name: '左上', value: 1 },
                { name: '中上', value: 2 },
                { name: '右上', value: 3 },
                { name: '左中', value: 4 },
                { name: '正中', value: 5 },
                { name: '右中', value: 6 },
                { name: '左下', value: 7 },
                { name: '中下', value: 8 },
                { name: '右下', value: 9 }
            ]
        }
    },
    watch: {
        myObj(newValue) {
            // this.myObj = newValue
            console.log('PhotoClassifyPlatProp watch', newValue)
        }
    }
}
</script>

<style scoped lang="less">
.box {
    padding: 15px;
}
</style>